// extracted by mini-css-extract-plugin
export var columnItem = "_dx-3";
export var columnItemDraggable = "_dx-5";
export var dragHandle = "_dx-0";
export var dragHandleHovered = "_dx-1";
export var dropdown = "_dx-6";
export var dropdownContent = "_dx-8";
export var dropdownInner = "_dx-7";
export var filterDropdownHeader = "_dx-9";
export var icon = "_dx-2";
export var moveToTopButton = "_dx-4";
export var sectionDivider = "_dx-a";